import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

const links = [
  {
    id: "linkedin",
    href: "https://www.linkedin.com/in/iamsinghshubhamm/",
    label: "LinkedIn",
    icon: <FaLinkedin size={20} />,
  },
  {
    id: "github",
    href: "https://www.github.com/iamsinghshubhamm",
    label: "GitHub",
    icon: <FaGithub size={20} />,
  },
  // {
  //   id: "email",
  //   href: "mailto:iamsinghshubhamm@gmail.com",
  //   label: "Email",
  //   icon: <HiOutlineMail size={18} />,
  // },
  // {
  //   id: "resume",
  //   href: "/resume.html",
  //   label: "Resume",
  //   icon: <BsFillPersonLinesFill size={18} />,
  // },
];

const SocialLinks = () => {
  return (
    <aside className="fixed bottom-[15%] right-5 z-40 hidden flex-col gap-3 xl:flex">
      {links.map((link) => (
        <a
          key={link.id}
          href={link.href}
          target={link.id === "email" ? undefined : "_blank"}
          rel={link.id === "email" ? undefined : "noreferrer"}
          className="group flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-[#08111d]/75 text-slate-300 backdrop-blur-xl transition hover:-translate-y-1 hover:border-[#f59e0b]/60 hover:text-white"
          aria-label={link.label}
        >
          {link.icon}
        </a>
      ))}
    </aside>
  );
};

export default SocialLinks;
